import { useNavigate } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate, money } from "@/lib/api";

export const TripTable = ({ trips, showCustomer, showDriver, testId = "trips-table" }) => {
  const nav = useNavigate();
  if (!trips.length) return <p data-testid={`${testId}-empty`} className="py-10 text-center text-sm text-zinc-500">No trips yet.</p>;
  return (
    <div className="overflow-x-auto">
      <Table data-testid={testId}>
        <TableHeader>
          <TableRow className="border-amber-500/10 hover:bg-transparent">
            <TableHead className="lux-eyebrow">Date</TableHead>
            <TableHead className="lux-eyebrow">Pickup</TableHead>
            {showCustomer && <TableHead className="lux-eyebrow">Customer</TableHead>}
            {showDriver && <TableHead className="lux-eyebrow">Driver</TableHead>}
            <TableHead className="lux-eyebrow">Stops</TableHead>
            <TableHead className="lux-eyebrow">Miles</TableHead>
            <TableHead className="lux-eyebrow">Total</TableHead>
            <TableHead className="lux-eyebrow">Status</TableHead>
            <TableHead className="lux-eyebrow">Feedback</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {trips.map((t) => (
            <TableRow key={t.id} data-testid={`trip-row-${t.id}`} onClick={() => nav(`/trips/${t.id}`)} className="cursor-pointer border-white/5 transition-colors hover:bg-amber-400/5">
              <TableCell className="whitespace-nowrap text-zinc-300">{fmtDate(t.timestamps?.created_at)}</TableCell>
              <TableCell className="max-w-[220px] truncate text-zinc-300">{t.pickup.address}</TableCell>
              {showCustomer && <TableCell className="text-zinc-300">{t.customer_name}</TableCell>}
              {showDriver && <TableCell className="text-zinc-300">{t.driver_name || "—"}</TableCell>}
              <TableCell className="text-zinc-300">{t.stops.length}</TableCell>
              <TableCell className="tabular-nums text-zinc-300">{t.total_miles ?? t.trip_miles}</TableCell>
              <TableCell className="tabular-nums text-amber-100">{money(t.fare.total)}{t.payment?.method_label && <span data-testid={`trip-method-${t.id}`} className="block whitespace-nowrap text-[11px] text-zinc-500">{t.payment.method_label}</span>}</TableCell>
              <TableCell><StatusBadge status={t.status} /></TableCell>
              <TableCell>{t.driver_id && t.status !== "awaiting_payment" && (
                <button data-testid={`trip-feedback-link-${t.id}`} onClick={(e) => { e.stopPropagation(); nav(`/trips/${t.id}/feedback`); }} className="whitespace-nowrap text-xs font-medium text-amber-300 hover:text-amber-200">Feedback</button>
              )}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
